import React from 'react';
import { colors, spacing, shadows } from '../../../design/tokens';

export const Footer: React.FC = () => {
  return (
    <footer style={{ 
      padding: `${spacing.xxl} ${spacing.xl}`, 
      backgroundColor: colors.neutral[1000], 
      color: 'white',
      borderTop: `1px solid ${colors.neutral[800]}`,
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: spacing.xxl, marginBottom: spacing.xxl }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: spacing.sm, marginBottom: spacing.lg }}>
              <div style={{ 
                width: '28px', 
                height: '28px', 
                backgroundColor: colors.brand.main, 
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '16px'
              }}>E</div>
              <div style={{ fontSize: '20px', fontWeight: 800, color: 'white', letterSpacing: '-0.5px' }}>Exibrain</div>
            </div>
            <p style={{ color: colors.neutral[400], lineHeight: 1.6, fontSize: '14px' }}>
              The world's first autonomous code remediation engine. Built for reliability, scale, and security.
            </p>
          </div>
          
          <div>
            <h4 style={{ fontSize: '18px', fontWeight: 700, marginBottom: spacing.lg }}>Platform</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: spacing.md }}><a href="#features" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>Features</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#how-it-works" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>How it Works</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>Documentation</a></li>
            </ul>
          </div>

          <div>
            <h4 style={{ fontSize: '18px', fontWeight: 700, marginBottom: spacing.lg }}>Company</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>About Us</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>Careers</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>Terms of Service</a></li>
            </ul>
          </div>

          <div>
            <h4 style={{ fontSize: '18px', fontWeight: 700, marginBottom: spacing.lg }}>Connect</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>X (Twitter)</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>GitHub</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>LinkedIn</a></li>
              <li style={{ marginBottom: spacing.md }}><a href="#" style={{ color: colors.neutral[400], textDecoration: 'none', fontSize: '14px' }}>Status Page</a></li>
            </ul>
          </div>
        </div>

        <div style={{ 
          paddingTop: spacing.xl, 
          borderTop: `1px solid ${colors.neutral[900]}`, 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          color: colors.neutral[500],
          fontSize: '14px'
        }}>
          <div>© 2026 Exibrain. All rights reserved.</div>
          <div style={{ display: 'flex', gap: spacing.lg }}>
            <span style={{ cursor: 'pointer' }}>Privacy</span>
            <span style={{ cursor: 'pointer' }}>Security</span>
            <span style={{ cursor: 'pointer' }}>GDPR</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
